import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";
import { PageShell } from "../components/common/PageShell";
import { EmptyState } from "../components/ui/EmptyState";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFoundPage() {
	const { t } = useTranslation();
	usePageMeta({
		title: t("meta.pageTitle", { page: t("notFound.title") }),
		description: t("notFound.description"),
	});

	return (
		<PageShell>
			{/* React 19 hoists this into <head>: a client-rendered 404 must never be indexed. */}
			<meta name="robots" content="noindex" />
			<EmptyState
				icon={Compass}
				title={t("notFound.title")}
				description={t("notFound.description")}
				action={
					<Link to="/" className="btn-primary">
						{t("notFound.backHome")}
					</Link>
				}
			/>
		</PageShell>
	);
}
